export const handleImageError = (event, fallbackSrc = '/placeholder-image.png') => {
    if (event.target.src !== fallbackSrc) { 
        event.target.onerror = null;
        event.target.src = fallbackSrc;
    }
}; 